import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  CardContent,
  CardHeader,
  Dialog,
  IconButton,
  Table,
  TableCell,
  TableRow,
  Box,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAnnouncements } from "./AnnoucementsContext";

const AnnouncementLog = () => {
  const [open, setOpen] = useState(false);
  const {
    selectedAnnoucementLog,
    selectedAnnoucementLogs,
    setSelectedAnnouncementLog,
  } = useAnnouncements();

  useEffect(() => {
    setOpen(selectedAnnoucementLog !== null);
  }, [selectedAnnoucementLog]);

  const onClose = (e, reason) => {
    setSelectedAnnouncementLog(null);
  };

  return (
    <Dialog fullWidth maxWidth onClose={onClose} open={open}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          // color: (theme) => theme.palette.grey[1500],
        }}
      >
        <CloseIcon />
      </IconButton>
      {/* <Card sx={{ overflow: "auto" }}> */}
      <Card sx={{ borderRadius: 3 }}>
        <CardHeader
          title={<font className="layer-title"> Announcement Logs </font>}
          sx={{ pb: 0, paddingLeft: 1, paddingRight: 1 }}
          align="center"
          className={"styledtablerow"}
        />

        <CardContent sx={{ paddingTop: 1, paddingLeft: 0, paddingRight: 0 }}>
          {selectedAnnoucementLogs && (
            <Table size="small">
              <TableRow className="report-header">
                <TableCell>Log Id</TableCell>
                <TableCell>Announcement Id</TableCell>
                <TableCell>Operator</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Updated Time</TableCell>
                <TableCell>Mode</TableCell>
              </TableRow>

              {selectedAnnoucementLogs.map((eachannounceLog, idx) => {
                return (
                  <TableRow className={idx % 2 === 0 ? "styledtablerow" : ""}>
                    <TableCell>{eachannounceLog.id}</TableCell>
                    <TableCell>{eachannounceLog.announcementId}</TableCell>
                    <TableCell>{eachannounceLog.operator}</TableCell>
                    <TableCell>{eachannounceLog.announcementTitle}</TableCell>
                    <TableCell>{eachannounceLog.timestamp}</TableCell>
                    <TableCell>{eachannounceLog.updateType}</TableCell>
                  </TableRow>
                );
              })}
            </Table>
          )}
          {!selectedAnnoucementLogs && (
            <Box
              sx={{
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                padding: 10,
                width: "100%",
              }}
            >
              <CircularProgress sx={{ margin: "auto" }} />
            </Box>
          )}
        </CardContent>
      </Card>
    </Dialog>
  );
};

export default AnnouncementLog;
